var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button","aria-label":_vm.ariaLabel,"id":_vm.id},on:{"click":function($event){return _vm.$emit('click', _vm.action)}}},[_c('span',[_vm._v("\n    "+_vm._s(_vm.buttonLabel)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }